import _ from 'lodash'
import { getEpochTimeFromMySQLDateTime } from 'Helper/timeHelper'

const initialState = {
  movement: {
    clientTick: null,
    mod: null,
    epochTime: null,
    clientDelta: 0,
    refreshStartTick: null,
    refreshOffset: 0,
  },
  instances: [],
  showOptionsOnId: {
    menu: null,
    modal: null,
    skinTestTimerTool: null,
    patientDetails: null,
  },
}

const timerReducer = (state = initialState, action) => {
  switch(action.type) {
    case 'TIMER_MOVEMENT_TICK':
      return {
        ...state,
        movement: {
          ...state.movement,
          clientTick: action.clientTick,
          mod: action.mod,
          epochTime: action.epochTime,
        }
      }
    case 'STORE_TIMER_READ_ALL':
      return {
        ...updateClientDelta(state, action),
        instances: action.result.map(processServerInstance),
      }
    case 'STORE_TIMER_CREATE':
      return {
        ...updateClientDelta(state, action),
        instances: [
          ...state.instances,
          processServerInstance(action.result),
        ],
      }
    case 'STORE_TIMER_DELETE':
      return {
        ...state,
        instances: _.reject(state.instances, { timer_id: action.result.timer_id })
      }
    case 'TIMER_OPTIONS_SHOW':
      return {
        ...state,
        showOptionsOnId: {
          [action.timerContext.view]: action.timer_id,
        },
      }
    case 'TIMER_OPTIONS_HIDE':
      return {
        ...state,
        showOptionsOnId: _.mapValues(state.showOptionsOnId, () => null),
      }
    default:
      return state
  }
}

const updateClientDelta = (state, action) => {
  const serverEpochTime = getEpochTimeFromMySQLDateTime(
    action.server_time.current_date,
    action.server_time.current_time
  )
  return {
    ...state,
    movement: {
      ...state.movement,
      clientDelta: Math.floor(Date.now() / 1000) - serverEpochTime,
      refreshStartTick: state.movement.clientTick,
      refreshOffset: new Date(serverEpochTime * 1000).getSeconds(),
    }
  }
}

const processServerInstance = (instance) => {
  let payload = {}
  if(instance.payload_json) {
    payload = JSON.parse(instance.payload_json)
  }
  return {
    ...instance,
    start_time: getEpochTimeFromMySQLDateTime(instance.start_time),
    payload,
  }
}

export default timerReducer
